import { GroupByMode, ID, Tag, TaskGroupBy } from '@griply/types';

export type GetTagCustomOrderByGroupingOptions = {
  groupBy: TaskGroupBy | undefined | null;
  tag?: Tag;
  noGroupingKey: string;
};

export const getTagCustomOrderByGrouping = ({
  groupBy,
  tag,
  noGroupingKey,
}: GetTagCustomOrderByGroupingOptions): Record<ID, ID[]> => {
  if (!tag?.id) {
    return {};
  }

  if (groupBy === GroupByMode.None) {
    return { [noGroupingKey]: tag.taskSorting ?? [] };
  }

  const resolvedGroupBy = (
    [GroupByMode.LifeArea].includes(groupBy as GroupByMode)
      ? GroupByMode.Priority
      : groupBy ?? GroupByMode.Priority
  ) as Exclude<GroupByMode, GroupByMode.None | GroupByMode.LifeArea>;

  return tag.customTaskOrder?.[resolvedGroupBy] ?? {};
};
